module.exports = __webpack_public_path__ + "static/zama-3-7f29f581cb50070e126edd4174a022eb.gif";